import eyeIcon from './../Assets/icons/eye 1.svg'
import editIcon from './../Assets/icons/Un-Checkbox.svg'

export const TABLE_HEADERS = [
    // "Sr No.",
    // "Extended Warranty Name",
    "Product Name",
    "PO Number",
    "Dealer Name",
    "Item",
    "Item Type",
    "Warranty Type",
    "Warranty Category",
    "Remark",
    "Status",
    // "Action"
  ];
  
  export const TABLE_DATA = [
    { id: 1, days: "One Month", description:"lorem ipsum",status: "Active", actions: "Edit/Delete" },
    { id: 2, days: "Two Month", description:"lorem ipsum",  status: "Inactive", actions: "Edit/Delete" },
    { id: 3, days: "Three Month", description:"lorem ipsum",  status: "Active", actions: "Edit/Delete" },
  ];
  
  export const keyMapping = {
    // "Sr No.": "Sr No.",
    "Extended Warranty Name": "extended_warranty_name",
    "Product Name":"productname",
    "PO Number":"po_number",
    "Dealer Name":"dealer_name",
    "Item":"item_name",
    "Item Type":"itemtype",
    "Warranty Category":"warranty_category",
    "Warranty Type":"warranty_type_desc",
    "Remark":"remark",    
    "Status": "status", 
    // "Action": [
    //     { type: "edit", icon: editIcon, label: "Edit" },
        
    //   ]
  };